import { Select, SelectContent, SelectFieldTrigger, SelectItem, SelectValue } from '@/design-system/components/ui';

interface TierOption {
  id: string;
  name: string;
  rank: number;
  audienceId: string | null;
  requiresManualProjectApproval: boolean;
}

interface AffiliateTierSelectProps {
  value: string | undefined;
  tiers: TierOption[];
  onValueChange: (value: string) => void;
  placeholder?: string;
}

export function AffiliateTierSelect({
  value,
  tiers,
  onValueChange,
  placeholder = 'Select a tier',
}: AffiliateTierSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectFieldTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectFieldTrigger>
      <SelectContent>
        {tiers.map((tier) => {
          const isDefault = tier.audienceId === null;

          return (
            <SelectItem key={tier.id} value={tier.id}>
              <span className="tw:block tw:min-w-0 tw:max-w-full tw:truncate">
                {tier.name} <span className="tw:text-xs tw:text-muted-foreground">Rank #{tier.rank}</span>
                {isDefault && <span className="tw:text-xs tw:text-muted-foreground tw:ml-1">(default)</span>}
              </span>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
